import { css } from 'styled-components';

import { cssDeclaration } from '../_ThemeTwo_/Utils/Styles/cssDeclaration';

import { commonInputStyles, IInputProps } from './InputCommon';

export interface ISelectInputProps {
  inline?: boolean;
}

export const SelectInputStyle = css<ISelectInputProps & IInputProps>`
  ${commonInputStyles}

  background-color: transparent;
  background-position: right 0.5em center;
  background-repeat: no-repeat;
  background-size: auto 15px;
  cursor: pointer;

  ${({ inline }) => inline && `
    padding-right: 2em;
  `}

  &:hover,
  &:focus {
    border: ${({ theme: { input } }) => input.borderWidth} solid ${({ theme: { input } }) => input.colorFocus};
  }

  ${({ theme, alert }) => {
    const { input } = theme;

    return css`
      ${input.borderData && css`
        border: none;
        /* border */ ${cssDeclaration(theme.themeTwo, 'border', input.borderData)};
      `}

      ${input.state && css`
        ${input.state.error && alert && css`
          color: ${input.state.error.colorText && input.state.error.colorText};
          /* border */ ${input.state.error.border && cssDeclaration(theme.themeTwo, 'border', input.state.error.border)};
        `}

        &:hover {
          /* border */
          ${input.state.hover && input.state.hover.border && cssDeclaration(theme.themeTwo, 'border', input.state.hover.border)};
        }

        &:focus {
          /* outline */
          ${input.state.focus && input.state.focus.outline && cssDeclaration(theme.themeTwo, 'outline', input.state.focus.outline)};
          /* border */
          ${input.state.focus && input.state.focus.border && cssDeclaration(theme.themeTwo, 'border', input.state.focus.border)};
        }
      `}
    `;
  }}

  &::-ms-expand {
    display: none;
  }
`;
